import React from 'react';
import PointManagementFrontDeskList from './components/PointManagementFrontDeskList';

const PointManagementFrontDesk = () => <PointManagementFrontDeskList />;

export default PointManagementFrontDesk;
